import { render, staticRenderFns } from "./traceInfo.vue?vue&type=template&id=22d5576b&scoped=true&"
import script from "./traceInfo.vue?vue&type=script&lang=js&"
export * from "./traceInfo.vue?vue&type=script&lang=js&"
import style0 from "./traceInfo.vue?vue&type=style&index=0&id=22d5576b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d5576b",
  null
  
)

export default component.exports